import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index/index'
import login from '@/components/index/login'
import defaultIndex from '@/components/index/defaultIndex'

import group from '@/components/elite/group'
import parner from '@/components/elite/parner'
import lawer from '@/components/elite/lawer'
import consultant from '@/components/elite/consultant'
import lawerDetail from '@/components/lawerDetail'


import msg from '@/components/msg'
import message from '@/components/msg/msg'
import honour from '@/components/msg/honour'


import business from '@/components/business'
import businessIndex from '@/components/business/default'
import businessSub from '@/components/business/sub'

import consumer from '@/components/consumer/index'
import consumerIndex from '@/components/consumer/default'

import comment from '@/components/comment/index'
import commentIndex from '@/components/comment/default'
import commentTheme from '@/components/comment/theme'
import commentDiscuss from '@/components/comment/discuss'


import join from '@/components/join/index'
import joinIndex from '@/components/join/default'
import joinTalent from '@/components/join/talent'


Vue.use(Router)

export default new Router({
  routes: [
    { 
        path: '/',
        name: 'root',
        component: index,
        children: [

            // 首页
            {
                path: '',
                name: 'index',
                component: defaultIndex,
            },

            // 精英
            {
                path: 'elite',
                name: 'group',
                component: group,
                children: [
                    { path: '0', name: 'parner', component: parner },
                    { path: '1', name: 'lawer', component: lawer },
                    { path: '2', name: 'consultant', component: consultant },
                    { path: 'lawerDetail/:id', name: 'lawerDetail', components: {lawerDetail}  },
                ] 
            },
            

            // 讯息
            { 
                path: 'information', 
                name: 'msg',
                component: msg,
                children: [
                    { path: '0', name: 'message', component: message },
                    { path: '1', name: 'honour', component: honour },
                ]
            },


            //  业务 
            { 
                path: 'cases', 
                name: 'business',
                component: business,
                children: [
                    { path: ':id', name: 'businessIndex', component: businessIndex,
                        children: [
                            { path: ':sid', name: 'businessSub', component: businessSub }
                        ]
                    },
                ]
            },

            // 评述
            { 
                path: 'activity', 
                name: 'comment',
                component: comment,
                children: [
                    { path: '0', name: 'commentIndex', component: commentIndex },
                    { path: '1', name: 'commentTheme', component: commentTheme },
                    { path: '2', name: 'commentDiscuss', component: commentDiscuss },
                ]
            },
            
            // 顾客
            { 
                path: 'consumer', 
                name: 'consumer',
                component: consumer,
                children: [
                    { path: '0', name: 'consumerIndex', component: consumerIndex },
                ]
            },

            // 加入我们
            { 
                path: 'recruit', 
                name: 'join',
                component: join,
                children: [
                    { path: '0', name: 'joinIndex', component: joinIndex },
                    { path: '1', name: 'joinTalent', component: joinTalent },
                ]
            },
        ]
    },
    { path: '/login', name: 'login', component: login },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js